var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.293 0C4.166 0 0 4.166 0 9.293c0 5.126 4.166 9.292 9.293 9.292a9.233 9.233 0 0 0 5.432-1.76L21.916 24l1.537-1.537-7.106-7.123a9.25 9.25 0 0 0 2.238-6.047C18.585 4.166 14.42 0 9.293 0Zm0 1.093a8.19 8.19 0 0 1 8.199 8.2 8.19 8.19 0 0 1-8.2 8.199 8.19 8.19 0 0 1-8.199-8.2 8.19 8.19 0 0 1 8.2-8.199Z"
  })));
};
export { SvgSearch as ReactComponent };